webpackJsonp([0,2],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(7)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(3),
  /* template */
  __webpack_require__(11),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highlightjs__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highlightjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_highlightjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highlightjs_styles_darcula_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highlightjs_styles_darcula_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_highlightjs_styles_darcula_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_scrollbar_custom_vue_scrollbar_custom_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_scrollbar_custom_vue_scrollbar_custom_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__vue_scrollbar_custom_vue_scrollbar_custom_vue__);







/* harmony default export */ __webpack_exports__["default"] = {
  name: 'app',
  components: {
    vScrollbar: __WEBPACK_IMPORTED_MODULE_2__vue_scrollbar_custom_vue_scrollbar_custom_vue___default.a
  },
  data: function data() {
    return {
      testArr: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    };
  },

  methods: {
    addContent: function addContent() {
      var _this = this;

      var ii = this.testArr.length + 1;
      var len = this.testArr.length + 11;
      for (var i = ii; i < len; i++) {
        this.testArr.push(i);
      }
      this.$nextTick(function () {
        _this.$refs.vScrollbar6.reCalcu();
      });
    },
    scrollFn: function scrollFn(e) {
      console.log(e.type);
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_highlightjs___default.a.initHighlightingOnLoad();
  }
};

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__v_drag_v_drag_js__ = __webpack_require__(5);




/* harmony default export */ __webpack_exports__["default"] = {
  name: 'vue-scrollbar-custom',
  data: function data() {
    return {
      msg: 'this is from vue-scrollbar-custom.vue',
      timer: null,
      containerHeight: '',
      contentHeight: '',
      barContainerHeight: ''
    };
  },

  props: {
    isTopBar: {
      type: Boolean,
      default: false
    },
    isHideBar: {
      type: Boolean,
      default: false
    },

    barContainerStyle: {
      type: Object,
      default: function _default() {
        return {
          width: '8px'
        };
      }
    },

    barStyle: {
      type: Object,
      default: function _default() {
        return {
          width: '6px',
          borderRadius: this.isHideBar ? '3px' : '',
          background: '#ccc'

        };
      }
    },

    topBarStyle: {
      type: Object,
      default: function _default() {
        return {
          height: '3px',
          backgroundColor: '#17ce28'
        };
      }
    }
  },
  computed: {
    barHeight: function barHeight() {
      return this.barContainerHeight * this.containerHeight / this.contentHeight;
    },
    transform: function transform() {
      return (this.contentHeight - this.containerHeight) / (this.barContainerHeight - this.barHeight);
    }
  },
  methods: {
    needScroll: function needScroll() {
      var _this = this;

      if (this.isTopBar) return;
      this.$nextTick(function () {
        _this.$refs.bar.parentNode.style.opacity = _this.containerHeight >= _this.contentHeight ? '0' : '1';
      });
    },
    reCalcu: function reCalcu() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.setContainerHeight();
        _this2.setContentHeight();
        _this2.setBarContainerHeight();
        _this2.setBarHeight();
        _this2.initContentWidth();
        _this2.getTransformTop();
        _this2.syncTopBarWidth();
        _this2.barScroll();
      });
      this.needScroll();
    },
    setBarContainerHeight: function setBarContainerHeight() {
      if (this.isTopBar) return;
      this.barContainerHeight = this.$refs.bar.parentNode.clientHeight;
    },
    setContainerHeight: function setContainerHeight() {
      this.containerHeight = this.$refs.innerContainer.offsetHeight;
    },
    setContentHeight: function setContentHeight() {
      this.contentHeight = this.$refs.content.offsetHeight;
    },
    initContentWidth: function initContentWidth() {
      var paddingWidth = this.$refs.barContainer && !this.isHideBar ? this.$refs.barContainer.offsetWidth : 0;
      this.$refs.content.style.width = this.$refs.container.clientWidth - paddingWidth + 'px';
      this.$refs.content.style.paddingRight = paddingWidth + 'px';
    },
    centerBar: function centerBar() {
      if (this.isTopBar) return;

      var left = (this.$refs.bar.parentNode.clientWidth - this.$refs.bar.offsetWidth) / 2 + 'px';
      this.$refs.bar.style.left = left;
    },
    barHover: function barHover() {

      this.clearTimer();
      this.showBar();
    },
    showBar: function showBar() {
      if (!this.isHideBar) return;
      this.$refs.bar.style.opacity = "1";
    },
    timeOutHideBar: function timeOutHideBar() {
      var _this3 = this;

      if (!this.isHideBar) return;

      this.timer = setTimeout(function () {
        _this3.$refs.bar.style.opacity = "0";
      }, 1500);
    },
    clearTimer: function clearTimer() {
      if (!this.isHideBar) return;

      if (this.timer) clearTimeout(this.timer);
    },
    getTransformTop: function getTransformTop() {
      return this.$refs.innerContainer.scrollTop / (this.contentHeight - this.containerHeight);
    },
    setBarHeight: function setBarHeight() {
      if (this.isTopBar) return;
      this.$refs.bar.style.height = this.barHeight + 'px';
    },
    barScroll: function barScroll(e) {

      if (e) this.$emit('scroll', e);

      this.clearTimer();
      this.showBar();
      this.timeOutHideBar();

      if (this.isTopBar) {
        this.syncTopBarWidth();
        return;
      }

      this.$refs.bar.style.top = this.$refs.innerContainer.scrollTop / this.transform + 'px';
    },
    syncContent: function syncContent() {
      if (this.isTopBar) return;
      this.$refs.innerContainer.scrollTop = this.$refs.bar.offsetTop * this.transform;
    },
    syncTopBarWidth: function syncTopBarWidth() {
      if (this.isTopBar) this.$refs.topBar.style.width = this.$refs.container.offsetWidth * this.getTransformTop() + 'px';
    }
  },
  created: function created() {
    if (this.isTopBar && this.isHideBar) throw 'isTopBar and isHideBar can\'t at the same time to true';
  },
  mounted: function mounted() {
    this.setContainerHeight();
    this.setContentHeight();
    this.setBarContainerHeight();

    this.needScroll();

    this.initContentWidth();

    this.centerBar();

    this.setBarHeight();
  },

  directives: {
    drag: __WEBPACK_IMPORTED_MODULE_0__v_drag_v_drag_js__["a" /* default */]
  }
};

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var vDrag = {
  inserted: function inserted(el, binding) {
    el.style.position = 'absolute';
    el.style.cursor = 'default';

    if (getComputedStyle(el, null).position === 'static') {
      el.parentNode.style.position = 'relative';
    }

    var mouseDownFn = function mouseDownFn(e) {

      var disX, disY;
      if (!binding.modifiers.dragY) disX = e.clientX - el.offsetLeft;
      if (!binding.modifiers.dragX) disY = e.clientY - el.offsetTop;
      var mouseMoveFn = function mouseMoveFn(e) {
        e.preventDefault();
        var left = e.clientX - disX;
        var top = e.clientY - disY;

        if (left < 0) {
          left = 0;
        } else if (left > el.parentNode.clientWidth - el.offsetWidth) {
          left = el.parentNode.clientWidth - el.offsetWidth;
        }

        if (top < 0) {
          top = 0;
        } else if (top > el.parentNode.clientHeight - el.offsetHeight) {
          top = el.parentNode.clientHeight - el.offsetHeight;
        }
        el.style.left = left + 'px';
        el.style.top = top + 'px';

        if (binding.value && binding.value.ondrag) {
          if (typeof binding.value.ondrag != 'function') throw 'ondrag: should be a function';
          binding.value.ondrag(e, { left: left, top: top });
        }
      };

      document.addEventListener('mousemove', mouseMoveFn);

      var mouseUpFn = function mouseUpFn() {
        document.removeEventListener('mousemove', mouseMoveFn);
        document.removeEventListener('mouseup', mouseUpFn);
      };

      document.addEventListener('mouseup', mouseUpFn);
    };

    el.addEventListener('mousedown', mouseDownFn);
  }
};
/* harmony default export */ __webpack_exports__["a"] = vDrag;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(8)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(4),
  /* template */
  __webpack_require__(12),
  /* scopeId */
  "data-v-bc4c43fc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('h2', [_vm._v("1.默认样式")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('v-scrollbar', {
    staticClass: "vScrollbar1",
    on: {
      "scroll": _vm.scrollFn
    }
  }, _vm._l((30), function(n) {
    return _c('h1', [_vm._v("default")])
  })), _c('h2', [_vm._v("2.不滚动时隐藏滚动条")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('v-scrollbar', {
    staticClass: "vScrollbar2",
    attrs: {
      "isHideBar": true
    }
  }, _vm._l((30), function(n) {
    return _c('h3', [_vm._v(":isHideBar=\"true\"")])
  })), _c('h2', [_vm._v("3.顶部滚动条")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('v-scrollbar', {
    staticClass: "vScrollbar3",
    attrs: {
      "isTopBar": true
    }
  }, _vm._l((30), function(n) {
    return _c('h3', [_vm._v(":isTopBar=\"true\"")])
  })), _c('h2', [_vm._v("4.通过slot自定义复杂滚动条样式")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('v-scrollbar', {
    staticClass: "vScrollbar4",
    attrs: {
      "barContainerStyle": {
        width: '14px',
        background: '#282828',
        borderLeft: '1px solid #1d1d1d',
        borderRight: '1px solid #3e3e3b'
      },
      "barStyle": {
        width: '8px',
        border: '1px solid #191919',
        borderRadius: '5px',
        overflow: 'hidden'
      }
    }
  }, [_c('div', {
    style: ({
      width: '100%',
      height: '100%',
      background: '#454545',
      borderLeft: '1px solid #585858'
    }),
    slot: "barIn"
  }), _vm._l((30), function(n) {
    return _c('h3', [_vm._v(":isTopBar=\"true\"")])
  })], 2), _c('h2', [_vm._v("5.顶部滚动条上一个音乐的符号")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('v-scrollbar', {
    staticClass: "vScrollbar5",
    attrs: {
      "isTopBar": true
    }
  }, [_vm._l((30), function(n) {
    return _c('h3', [_vm._v(":isTopBar=\"true\"")])
  }), _c('div', {
    style: ({
      position: 'absolute',
      right: '0',
      top: '-5px',
      color: '#17ce28',
      zIndex: '1000'
    }),
    slot: "topBarIn"
  }, [_vm._v("♪")])], 2), _c('h2', [_vm._v("6.当滚动内容高度动态变化时，执行重新计算")]), _vm._v(" "), _c('h3', [_vm._v("html")]), _vm._v(" "), _c('pre', [_c('code', {
    staticClass: "highlight-js"
  }, [_vm._v("  <v-scrollbar  ref=\"vScrollbar6\" class=\"vScrollbar6\">\n    <h1 v-for=\"v in testArr\">" + _vm._s(_vm.v) + "</h1>\n    <button @click=\"addContent\"> add coontent </button>\n  </v-scrollbar>\n\n")])]), _vm._v(" "), _c('h3', [_vm._v("测试：用于增加内容的方法")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('v-scrollbar', {
    ref: "vScrollbar6",
    staticClass: "vScrollbar6"
  }, [_vm._l((_vm.testArr), function(v) {
    return _c('h1', [_vm._v(_vm._s(v))])
  }), _c('button', {
    on: {
      "click": _vm.addContent
    }
  }, [_vm._v(" add coontent")])], 2), _c('div', {
    staticStyle: {
      "height": "200px"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "highlight-html"
  }, [_vm._v("\n  <v-scrollbar class=\"vScrollbar1\">\n    <h1 v-for=\"n in 30\">default</h1>\n  </v-scrollbar>\n\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "highlight-html"
  }, [_vm._v("\n  <v-scrollbar class=\"vScrollbar2\" :isHideBar=\"true\">\n    <h3 v-for=\"n in 30\">:isHideBar=\"true\"</h3>\n  </v-scrollbar>\n\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', [_vm._v("  <v-scrollbar class=\"vScrollbar3\" :isTopBar=\"true\">\n    <h3 v-for=\"n in 30\">:isTopBar=\"true\"</h3>\n  </v-scrollbar>\n\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', [_vm._v("\n<v-scrollbar\n  class=\"vScrollbar4\"\n  :barContainerStyle=\"{width:'14px', background:'#282828' ,borderLeft:'1px solid #1d1d1d',borderRight:'1px solid #3e3e3b'}\"\n  :barStyle=\"{width:'8px',border:'1px solid #191919',borderRadius:'5px',overflow:'hidden'}\">\n\n  <div slot=\"barIn\" :style=\"{width:'100%',height:'100%',background:'#454545',borderLeft:'1px solid #585858'}\"></div>\n\n  <h3 v-for=\"n in 30\">:isTopBar=\"true\"</h3>\n</v-scrollbar>\n\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', [_vm._v("  <v-scrollbar class=\"vScrollbar5\" :isTopBar=\"true\">\n    <h3 v-for=\"n in 30\">:isTopBar=\"true\"</h3>\n    <div slot=\"topBarIn\" :style=\"{position:'absolute',right:'0',top:'-5px',color:'#17ce28',zIndex:'1000'}\">♪</div>\n  </v-scrollbar>\n\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "highlight-js"
  }, [_vm._v("  data() {\n    return {\n      testArr: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]\n    }\n  },\n\n  methods: {\n    addContent() {\n      var ii = this.testArr.length + 1\n      var len = this.testArr.length + 11\n      for (var i = ii; i < len; i++) {\n        this.testArr.push(i)\n      }\n      this.$nextTick(() => {\n        this.$refs.vScrollbar6.reCalcu() // 通过ref属性访问组件的方法reCalcu\n      })\n    }\n  }\n")])])
}]}

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "vue-scrollbar-custom"
  }, [_c('div', {
    ref: "innerContainer",
    staticClass: "scrollbar-container",
    on: {
      "scroll": _vm.barScroll
    }
  }, [_c('div', {
    ref: "content",
    staticClass: "content-container"
  }, [_vm._t("default")], 2)]), (!_vm.isTopBar) ? _c('div', {
    ref: "barContainer",
    staticClass: "scroll_bar_container",
    style: ([_vm.barContainerStyle, {
      background: _vm.isHideBar ? 'rgba(0,0,0,0)' : _vm.barContainerStyle.background
    }]),
    on: {
      "mouseover": _vm.barHover,
      "mouseout": _vm.timeOutHideBar
    }
  }, [_c('div', {
    directives: [{
      name: "drag",
      rawName: "v-drag.dragY",
      value: ({
        ondrag: _vm.syncContent
      }),
      expression: "{ondrag:syncContent}",
      modifiers: {
        "dragY": true
      }
    }],
    ref: "bar",
    staticClass: "scroll_bar",
    style: ([_vm.barStyle, {
      opacity: _vm.isHideBar ? 0 : 1
    }])
  }, [_vm._t("barIn")], 2)]) : _c('div', {
    staticClass: "topBar_container"
  }, [_c('div', {
    ref: "topBar",
    staticClass: "topBar",
    style: (_vm.topBarStyle)
  }, [_vm._t("topBarIn")], 2)])])
},staticRenderFns: []}

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);




new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ })
],[15]);


// WEBPACK FOOTER //
// static/js/app.f7b771a13808b72ab878.js